import React from 'react';
import './TableApplication.scss';
import { Col, Divider, Row, Table, Empty, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import useFetchCreatedApplication from '../hooks/SearchProduct/useFetchCreatedApplication';

interface JournalApplicationProps {
  dataAfterSubmitAndClear: any;
}

const TableApplication: React.FC<JournalApplicationProps> = ({
  dataAfterSubmitAndClear,
}) => {
  const { data, loading } = useFetchCreatedApplication(dataAfterSubmitAndClear);

  const columns = [
    {
      width: '20%',
      title: () => {
        return <span>Номер</span>;
      },
      dataIndex: ['ID', 'AGREEMENT_ID'],
      key: '1',
      render: (text, row) => (
        <Tooltip title="Открыть договор" mouseEnterDelay={1}>
          <Link to={`/genApplication/${row.ISN}`} className="contract-id">
            {row.ID}
          </Link>
        </Tooltip>
      ),
    },
    {
      width: '15%',
      dataIndex: 'STATUS_NAME',
      title: () => {
        return <span>Статус</span>;
      },
      key: '2',
    },
    {
      width: '20%',
      title: () => {
        return <span>Дата регистрации</span>;
      },
      dataIndex: 'DATEBEG',
      key: '3',
      render: (text, row) => <p>{text.split(' ')[0]}</p>,
    },
    {
      width: '15%',
      title: () => {
        return <span>Продукт</span>;
      },
      dataIndex: 'PRODUCT_NAME',
      key: '4',
      render: (text, row) => <p>{text}</p>,
    },
    {
      width: '15%',
      title: () => {
        return <span>Контрагент</span>;
      },
      dataIndex: 'SUBJ_NAME',
      key: '4',
      render: (text, row) => <p>{text}</p>,
    },
  ];

  return (
    <Row>
      <Col span={24}>
        <Divider />
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          rowKey="ID"
          locale={{
            emptyText: (
              <Empty description="Договоры не найдены с выбранными фильтрами" />
            ),
          }}
          className="c-table"
          scroll={{ x: 1000 }}
        />
      </Col>
    </Row>
  );
};

export default TableApplication;
